
const onAfterRenderClient = (pageContext: any)=>{
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'page_view', {
            page_path: window.location.pathname,
            page_title: document.title,
        });
    }
}

export {onAfterRenderClient}